import { render, staticRenderFns } from "./bridgeInfo.vue?vue&type=template&id=74c4b834&scoped=true&"
import script from "./bridgeInfo.vue?vue&type=script&lang=js&"
export * from "./bridgeInfo.vue?vue&type=script&lang=js&"
import style0 from "./bridgeInfo.vue?vue&type=style&index=0&id=74c4b834&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c4b834",
  null
  
)

export default component.exports